<template>
  <div class="api-filters-tab">
    <ApiTabEmptyState
      v-if="!filterCards.length"
      title="No filters yet"
      description="Create a filter to control exactly which of your populations and partner populations the API returns. Your filters and their IDs will appear here."
      create-cta-text="Create filter"
      :icon="['fak', 'filter']"
      @create="openCreate('filters')"
    />
    <template v-else>
      <ApiResourceCard
        v-for="filter in filterCards"
        :key="filter.id"
        :name="filter.name"
        :status="filter.status"
        :status-text="filter.statusText"
      >
        <template #actions>
          <ApiResourceCardActions
            action-text="Edit"
            :action-icon="['fak', 'edit']"
            :resource-name="filter.name"
            @action="openDetail('filters', filter.id)"
          />
        </template>
        <ApiCopyValue :value="filter.id" :label="`ID for ${filter.name}`" />
      </ApiResourceCard>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import { computed } from 'vue';

import ApiCopyValue from '../components/ApiCopyValue.vue';
import ApiResourceCard from '../components/ApiResourceCard.vue';
import ApiResourceCardActions from '../components/ApiResourceCardActions.vue';
import ApiTabEmptyState from '../components/ApiTabEmptyState.vue';
import { API_FILTER_FIXTURES } from '../fixtures/filters';
import useApiRoutes from '../useApiRoutes';

useHead({ title: 'API Filters - Crossbeam' });

const { openCreate, openDetail } = useApiRoutes();

const filterCards = computed(() =>
  API_FILTER_FIXTURES.map((filter) => ({
    id: filter.id,
    name: filter.name,
    status: filter.isCalculating ? ('warning' as const) : undefined,
    statusText: filter.isCalculating ? 'Pending' : '',
  })),
);
</script>
